export default __webpack_public_path__ + "static/hero-layer-6-extended-e9e869a9ec5ca1e1a922dfb33f7a7239.svg";